/** MODULES ROUTES */
export const MODULES_PATH = 'modules';

/** USERS ROUTES */
export const USERS_PATH = 'users';

/** GROUPS ROUTES */
export const GROUPS_PATH = 'groups';

/** ADMIN ROUTES */
export const ADMIN_PATH = 'admin';

/** DC CONSOLE ROUTES */
export const ROOT_ORGANIZATION_PATH = 'organization';
export const DETAILS_PATH = 'details';
export const ACCOUNT_PATH = 'profile';
export const TOKEN_LIST = 'tokens';
